import { Box, styled } from '@mui/material';

export const GalleryContainer = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '1rem',
  alignItems: 'flex-start',
  padding: '1rem',
  backgroundColor: '#FFF',
  width: '100%',
  minWidth: 0,
  overflow: 'auto',
  boxShadow: '0 -5px 15px 0 rgba(0, 0, 0, 0.12)',
  '&::-webkit-scrollbar': {
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#F3F4F6',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#D1D5DB',
    borderRadius: '3px',
    '&:hover': {
      backgroundColor: '#9CA3AF',
    },
  },
}));

export const AddImageButton = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '120px',
  width: '120px',
  height: '120px',
  borderRadius: '1rem',
  backgroundColor: theme.palette.grey[100],
  cursor: 'pointer',
  flexShrink: 0,
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
    transform: 'scale(1.05)',
  },
}));
